import React from 'react';
import PropTypes from 'prop-types';

const CardProfile = ({
  type,
  secondaryTitle,
  primaryTitle,
  tertiaryTitle,
  image,
  children,
  divider,
  id,
}) => {
  const iconType =
    (type === 'contact' && 'glyphicon glyphicon-user') ||
    (type === 'account' && 'glyphicon-pro glyphicon-pro-buildings-city');

  return (
    <div className={`Card__Profile ${divider ? 'Card__Profile--divider' : ''}`}>
      {!image &&
        <div className="Card__Profile__circle Card__Profile__silhouette">
          <div
            className="Card__Profile__silhouette--iconWrapper"
            id={`Card-profile-silhouette-wrapper-${id}`}
          >
            {!image && (
              <span
                id={`Card-profile-silhouette-icon-${id}`}
                className={`Card__Profile__icon ${iconType}`}
              />
            )}
          </div>
        </div>
      }
      {image &&
        <div
          className="Card__Profile__circle Card__Profile__image"
          id={`Card-profile-image-wrapper-${id}`}
        >
          <svg
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            style={{ backgroundImage: `url('${image}')` }}
            className="Card__Profile__image--clipped"
            alt={primaryTitle && primaryTitle}
            id={`Card-profile-image-${id}`}
          />
        </div>
      }
      <div className="Card__InfoBlock">
        {primaryTitle && <div className="Card__InfoBlock_description">{primaryTitle}</div>}
        {secondaryTitle && <div className="Card__InfoBlock_title">{secondaryTitle}</div>}
        {tertiaryTitle && <div className="Card__InfoBlock_tertiaryTitle">{tertiaryTitle}</div>}
        {children && <div className="Card__InfoBlock_children">{children}</div>}
      </div>
    </div>
  );
};

CardProfile.propTypes = {
  type: PropTypes.string,
  image: PropTypes.string,
  id: PropTypes.string,
  secondaryTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  primaryTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  tertiaryTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  divider: PropTypes.bool,
  children: PropTypes.object,
};

CardProfile.defaultProps = {
  type: 'contact',
  secondaryTitle: null,
  primaryTitle: null,
  tertiaryTitle: null,
  image: null,
  children: null,
  divider: false,
  id: 'profile',
};

export default CardProfile;
